<h2 class="sectionTitle"></h2>
<div class="form-container">
  <h4 class="section-title">{{ 'SHARED.Search' | translate}}</h4>
  <!--category-->
  <div class="form-group">
    <label for="category">{{'ADMIN_USER.E_TENDER_FORM.ETENDERS_CATEGORIES' | translate}}</label>
    <select id="category" name="category" class="form-control" [(ngModel)]="category">
      <option [value]="undefined" selected>{{ 'ADMIN_USER.SHARED.CHOOSE' | translate }}
      </option>
      <ng-container *ngFor="let tenderCategory of TenderCategories">
        <option *ngIf="displayedLang=='NameEN'" [value]="tenderCategory.Id">
          {{tenderCategory.NameEN}}
        </option>
        <option *ngIf="displayedLang=='NameAR'" [value]="tenderCategory.Id">
          {{tenderCategory.NameAR}}
        </option>
      </ng-container>
    </select>
  </div>
</div>
<div class="btns-holder text-center">
  <input type="button" class="btn btn-primary SCAcustomBtn" (click)="loadData()"
    value="{{ 'SHARED.Search' | translate}}" />
  <input type="button" class="btn btn-primary SCAcustomBtn" (click)="resetData()"
    value="{{ 'SHARED.ResetSearch' | translate}}" />
  <input type="button" class="SCAcustomBtn" *ngIf="!hideExportButton" (click)="ExportExcel()"
    value="{{ 'SHARED.REPORTS.EXPORT_EXCEL' | translate}}" />
</div>
<app-grid-view #ETenderList [customMenuTemplate]="tenderTemplate" [IsHtml]="IsHtml" [HasMenu]="HasMenu"></app-grid-view>

<ng-template #tenderTemplate let-item let-menuItems="menuItems">
  <li role="menuitem">
      <a class="dropdown-item" (click)="View(item.RequestId,item.ETenderType)">
         {{'ADMIN_USER.SHARED.VIEW'|translate}}
      </a>
  </li>
</ng-template>